import React from "react";
import "./ShootingEventHome.css";

function ShootingEventHome() {
    return (
        <div className="home-wrapper">

            {/* Hero */}
            <div className="home-hero">
                <h1>Witaj w Target Calculator!</h1>
                <p>Półautomatyczne skanowanie tarcz strzeleckich z liczeniem punktów, statystyki sesji i raporty PDF — wszystko w jednym miejscu.</p>
            </div>

            <p className="home-section-title">Obecnie obsługiwane konkurencje</p>
            <ul className="home-roadmap">
                <li><span className="home-roadmap-dot" />Pistolet pneumatyczny 10 m</li>
                <li><span className="home-roadmap-dot" />Karabin pneumatyczny 10 m</li>
                <li><span className="home-roadmap-dot" />Pistolet sportowy 25 m</li>
                <li><span className="home-roadmap-dot" />Pistolet centralnego zapłonu 25 m</li>
            </ul>

            {/* Jak zacząć */}
            <p className="home-section-title">Jak zacząć?</p>
            <div className="home-info-block">
                Zaloguj się na indywidualne konto testowe, do którego dostęp otrzymałeś. Następnie na górnym pasku kliknij <strong>„Dodaj sesję"</strong>.
                <br></br>
                <br></br>
                <i>Jeśli nie posiadasz jeszcze konta testowego, napisz do nas na adres <strong><a href="mailto:targetcalculator10.9@gmail.com">targetcalculator10.9@gmail.com</a></strong>.</i>
            </div>

            {/* Ankieta */}
            <div className="home-survey">
                <p>Po wypróbowaniu aplikacji bardzo prosimy o wypełnienie krótkiej ankiety. Zebrane odpowiedzi ukierunkują dalszy rozwój portalu.</p>
                <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSfZQjRUxnamm0_B7XY3zyhc-pwGrvrKC4JfzuMEX0KE2CUFIQ/viewform?usp=dialog"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Wypełnij ankietę →
                </a>
            </div>

            {/* Filmiki */}
            <p className="home-section-title">Demonstracja</p>
            <div className="home-videos">
                <div className="home-video-item">
                    <p>📱 Urządzenie mobilne</p>
                    <iframe
                        src="https://www.youtube.com/embed/JN2BY9nGP5k"
                        title="Target Calculator (alpha test) - demonstracja na urządzeniu mobilnym"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    />
                </div>
                <div className="home-video-item">
                    <p>💻 Komputer stacjonarny / laptop</p>
                    <iframe
                        src="https://www.youtube.com/embed/5S7UD9TP93g"
                        title="Target Calculator (alpha test) - demonstracja na komputerze stacjonarnym"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    />
                </div>
            </div>

            {/* Plany rozwoju */}
            <p className="home-section-title">Plany rozwoju</p>
            <ul className="home-roadmap">
                <li><span className="home-roadmap-dot" />Obliczanie punktów dziesiętnych dla konkurencji pneumatycznych</li>
                <li><span className="home-roadmap-dot" />Publiczne profile użytkowników z udostępnianiem swoich osiągnięć</li>
                <li><span className="home-roadmap-dot" />Obsługa większej liczby konkurencji</li>
                <li><span className="home-roadmap-dot" />Koleżeńskie sesje pojedynkowe z innymi użytkownikami</li>
                <li><span className="home-roadmap-dot" />Integracja z zawodami klubowymi</li>
                <li><span className="home-roadmap-dot" />Dodanie osobistego trenera opartego na AI</li>
            </ul>


            {/* Ostrzeżenie */}
            <div className="home-warning">
                <strong>⚠️ Wczesna wersja (alpha)</strong> — aplikacja może zawierać błędy, być niestabilna lub działać wolno. Za niedogodności przepraszamy.
                Wszelkie problemy prosimy zgłaszać w ankiecie lub bezpośrednio na adres:{" "}
                <strong>targetcalculator10.9@gmail.com</strong>
            </div>

        </div>
    );
}

export default ShootingEventHome;